<template>
	<GBBottomPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<div class="bottom-pane-window progress-rate"
			v-on:touchmove="onVScroll">
			<div class="bottom-pane-header">
				<div class="bottom-pane-header-title">スケジュール情報</div>
				<v-btn fab flat absolute class="pa-0 ma-0 bottom-pane-close"
					v-on:click= "onClose"
				>
					<v-icon>close</v-icon>
				</v-btn>
			</div>
			<div class="bottom-pane-content">
				<v-layout row wrap v-if="isChildren">
					<v-flex xs2 md1 mt-4 mb-5 style="font-size:16px;">
						件名
					</v-flex>
					<v-flex xs10 md5>
						<v-text-field
							v-model="schedule_title"
							v-on:input="onInputTitle"
							v-on:focus="onForcus"
							v-on:blur="onForcusOut"
							v-on:keydown="onKeyDown"
							v-bind:disabled=" !isEditable"
							v-bind:hint="title_hint"
							maxlength="20"
							counter
						></v-text-field>
					</v-flex>
					<v-flex xs2 md1 offset-xs0 offset-md1 mt-4 mb-5 style="font-size:16px;">
						色
					</v-flex>
					<v-flex xs10 md4 mt-4 mb-5 style="position: relative; padding-right: 60px;">
						<GBColors
							:items="selectedColor"
							:max_width="maxWidth"
							:all_show=false
							:type="typeColor"
							:select_type="typeSelect.SINGLE"
						/>
						<v-btn
							flat
							fab
							absolute
							class="btn-add-color"
							v-if="isEditable"
							v-on:click="onClickShowColorSelect"
						>
							<v-icon>color_lens</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
				<v-layout row wrap v-else-if="isChartPage">
					<v-flex xs2 md1 mt-4 mb-5 style="font-size:16px;">
						色
					</v-flex>
					<v-flex xs10 md11 mt-4 mb-5 style="position: relative; padding-right: 60px;">
						<GBColors
							:items="selectedColor"
							:max_width="maxWidth"
							:all_show=false
							:type="typeColor"
							:select_type="typeSelect.SINGLE"
						/>
						<v-btn
							flat
							fab
							absolute
							class="btn-add-color"
							v-if="isEditable"
							v-on:click="onClickShowColorSelect"
						>
							<v-icon>color_lens</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
				<v-layout row wrap style="margin-top:20px;">
					<v-flex xs2 md1 mt-4 style="font-size:16px;">
						進捗率
					</v-flex>
					<v-flex xs10 md11 px-2>
						<v-slider 
							class="align-center" 
							v-bind:value="setValue"
							v-on:input="onInput"
							v-bind:readonly="!isProgressRateEditable"
							v-statemachine="sm_pane"
							step="5" 
							ticks="always" 
							tick-size="1"
							:tick-labels="['0', null, '10', null, '20', null, '30', null, '40', null, '50', null, '60', null, '70', null, '80', null, '90', null, '100']"
							thumb-label="always"
							thumb-size="50">
						</v-slider>
					</v-flex>
				</v-layout>
			</div>
		</div>
	</GBBottomPane>
</template>
<script>
import GBBottomPane from './GBBottomPane';
import GBColors from './GBColors';
import MouseState from '../classes/MouseState';
import MouseStateMachine from '../classes/MouseStateMachine';
import Notification from '../classes/Notification';
import DataSetManager from '../classes/DataSetManager';
import Util from '../classes/Util';
import ScheduleListRow from '../data/ScheduleListRow';
import Color from '../data/Color';
import {COLOR_SELECT_TYPE} from '../data/Const';
import clonedeep from 'lodash/cloneDeep';

export default {
	name: 'GBBottomPaneProgressRateSetting',
	props: [
		'value',
		'fetch',
		'isEditable',
		'selected_color',
	],
	data: function() {
		const state_down = new MouseState({
				down: () => {
					this.startExclusive();
					this.sm_window.next(state_up);
				},
			});
		const state_up = new MouseState({
				up: (e) => {
					if (!e.touches) {
						let diffX = e.clientX - window.innerWidth + 1; //+1は微調整
						let diffY = e.clientY - this.$store.getters.height;
						if (e.clientX <= 0 ||
							e.clientY <= 0 ||
							diffX >= 0 ||
							diffY >= 0) {
								return;
						}
					}
					this.endExclusive();
					this.sm_window.next(state_nop);
				},
			});
		const state_nop = new MouseState({});
		return {
			sm_pane: new MouseStateMachine(state_down),
			sm_window: new MouseStateMachine(state_nop),
			dataset_manager: this.$store.getters.datasetManager,
			is_mousedown: false,
			is_exists: true,
			schedule_title: '',
			before_schedule_title: '',
			timer: null,
			title_hint: '',
			typeSelect: COLOR_SELECT_TYPE,
		}
	},
	components: {
		GBBottomPane,
		GBColors,
	},
	methods: {
		onClose: function() {
			if (this.value && this.value.callback)
				this.value.callback();
			this.$emit('close');
		},
		startExclusive: function(){
			this.dataset_manager.setBeforeDataset();
			this.$store.dispatch('startExclusive');
			this.is_mousedown = true;
		},
		endExclusive: function(){
			this.$store.dispatch('endExclusive');
			if(!this.is_exists) {
				this.$store.commit('addNotification', Notification.error('更新対象が削除されています', 'notificationCreateData'));
				this.is_exists = true;
				this.onClose();
			}
			if (this.is_mousedown) {
				this.updateProgressRate();
			}
			this.is_mousedown = false;
		},
		onVScroll: function(e) {
			let elm = e.target;
			let btn = elm.classList.contains('v-btn') ? elm : elm.closest('.v-btn');
			if (btn)
				return;

			let input = elm.classList.contains('v-input') ? elm : elm.closest('.v-input');
			if (input && !input.classList.contains('v-input--is-focused')){
				return;
			}
			
            if(document.getElementsByClassName('v-input--is-focused')[0])
                return;
			
			e.preventDefault();
		},
		onInput:function(e) {
			if (this.value) {
				this.value.schedule.progress_rate = e;
				this.$store.dispatch('updateProgressRate', {
					schedule_code: this.value.schedule.code, 
					project_code: this.value.schedule.project_code,
					member_code: this.value.schedule.member_code,
					progress_rate: this.value.schedule.progress_rate,
				}).then((res) => {
					this.is_exists = res;
					if (!this.is_mousedown) {
						if(!res) {
							this.$store.commit('addNotification', Notification.error('更新対象が削除されています', 'notificationCreateData'));
							this.is_exists = true;
							this.onClose();
						}
						this.updateProgressRate();
					}
				});
			}
		},
		onKeyDown: function(e) {
			if(!e.isComposing && e.code === 'Enter')
				return;
			if(this.timer !== null) {
				clearTimeout(this.timer);
				this.timer = null;
			}
			
			this.title_hint = '入力中';
			if(e.isComposing && e.code !== 'Enter')
				return;
			
			this.timer = setTimeout(() => {
				this.$store.dispatch('updateScheduleTitle', {
					schedule_code: this.value.schedule.code, 
					project_code: this.value.schedule.project_code,
					member_code: this.value.schedule.member_code,
					title: this.value.schedule.title,
				}).then((res) => {
					this.is_exists = res;
					if(!this.is_exists) {
						this.$store.commit('addNotification', Notification.error('更新対象が削除されています', 'notificationCreateData'));
						this.is_exists = true;
						this.title_hint = '';
						this.onClose();
					}
				});
				this.title_hint = '自動保存されました';
				this.updateTitle();
			}, 2000);
		},
		onInputTitle: function(e) {
			this.value.schedule.title = e;
			if (this.value) {
				this.$store.dispatch('updateScheduleTitle', {
					schedule_code: this.value.schedule.code, 
					project_code: this.value.schedule.project_code,
					member_code: this.value.schedule.member_code,
					title: this.value.schedule.title,
				}).then((res) => {
					this.is_exists = res;
				});
			}
		},
		onForcus: function() {
			this.dataset_manager.setBeforeDataset();
			this.before_schedule_title = this.schedule_title;
			this.title_hint = '入力中';
			this.$store.dispatch('startExclusive');
		},
		onForcusOut: function() {
			this.$store.dispatch('endExclusive');
			
			if(!this.is_exists) {
				this.$store.commit('addNotification', Notification.error('更新対象が削除されています', 'notificationCreateData'));
				this.is_exists = true;
				this.onClose();
			}
			if(this.timer !== null) {
				clearTimeout(this.timer);
				this.timer = null;
			}
			this.title_hint = '';
			this.updateTitle();
		},
		updateTitle: function() {
			if(!this.$store.getters.isUpdated)
				return;
			
			const onFail = async (err) => {
				this.schedule_title = this.before_schedule_title;
				const callback = {
					401: () => {
						this.logout();
					},
					409: () => {
						this.onClose();
					},
				};
				Util.updateFail(this.$store, err.response, callback);
				
				this.fetchData();
			};
			const onTokenFail = () => {
				this.logout();
			};
			
			this.dataset_manager.setAfterDataset();
			this.dataset_manager.syncTitle(null, onFail, onTokenFail);
		},
		updateProgressRate: function() {
			if(!this.$store.getters.isUpdated)
				return;
			
			const onFail = async (err) => {
				const callback = {
					401: () => {
						this.logout();
					},
					409: () => {
						this.onClose();
					},
				};
				Util.updateFail(this.$store, err.response, callback);
				
				this.fetchData();
			};
			const onTokenFail = () => {
				this.logout();
			};
			
			this.dataset_manager.setAfterDataset();
			this.dataset_manager.syncProgressRate(null, onFail, onTokenFail);
		},
		onApplyColor: function() {
			this.$store.dispatch('updateScheduleColor', {
				schedule_code: this.value.schedule.code, 
				project_code: this.value.schedule.project_code,
				member_code: this.value.schedule.member_code,
				color_code: this.selected_color[0].code,
			}).then((res) => {
				this.is_exists = res;
				if(!this.is_exists) {
					this.$store.commit('addNotification', Notification.error('更新対象が削除されています', 'notificationCreateData'));
					this.is_exists = true;
					this.onClose();
				}
				this.updateColor();
			});
		},
		updateColor: function() {
			if(!this.$store.getters.isUpdated)
				return;
			
			const onFail = async (err) => {
				const callback = {
					401: () => {
						this.logout();
					},
					409: () => {
						this.onClose();
					},
				};
				Util.updateFail(this.$store, err.response, callback);
				
				this.fetchData();
			};
			const onTokenFail = () => {
				this.logout();
			};
			
			this.dataset_manager.setAfterDataset();
			this.dataset_manager.syncColor(null, onFail, onTokenFail);
		},
		onClickShowColorSelect: function() {
			this.$emit('show-color-select', {
				color: clonedeep(this.selectedColor),
				type: this.typeColor,
				select_type: this.typeSelect.SINGLE,
			});
		},
		fetchData: async function() {
			let access_token = await DataSetManager.confirmAccessToken(this.$store);
			await this.dataset_manager[this.fetch](access_token)
				.then((data) => {
					this.$store.commit('createData', data);
				})
				.catch(async (e) => {
					let notification = null;
					switch(e.response.status) {
					case 400:
						notification = Notification.error('リクエストに失敗しました', 'notificationCreateData');
						break;
					case 401:
						notification = Notification.error('もう一度ログインしてください', 'notificationCreateData');
						this.logout();
						break;
					case 403:
						notification = Notification.error('権限がありません', 'notificationCreateData');
						this.logout();
						break;
					case 404:
						notification = Notification.error('契約者情報の取得に失敗しました', 'notificationCreateData');
						break;
					case 500:
						notification = Notification.error('情報の取得に失敗しました', 'notificationCreateData');
						break;
					case 504:
						notification = Notification.error('タイムアウトしました', 'notificationCreateData');
						break;
					default :
						notification = Notification.error('通信に失敗しました', 'notificationCreateData');
						break;
					}
					this.$store.commit('addNotification', notification);
				});
		},
		logout: function() {
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		setValue: function() {
			return this.value === null ? 0 : this.value.schedule.progress_rate;
		},
		isChildren: function() {
			if(this.value !== undefined && this.value !== null && this.isChartPage) {
				return this.value.schedule.member_code !== null && this.value.schedule.member_code !== undefined;
			}
			return false;
		},
		isChartPage: function() {
			return !this.$route.params.id;
		},
		isProgressRateEditable: function() {
			return this.$route.params.id || (!this.$route.params.id && this.isEditable);
		},
		selectedColor: function() {
			if (!this.display)
				return [];
				
			if(this.selected_color) {
				return this.selected_color;
			} else { 
				let color_code = this.value.schedule.color_code;
				if (this.isDefaultColor(color_code)) {
					if (this.$store.getters.isDisplayListTypeMember) {
						let member = this.$store.getters.mstMemberData(this.value.schedule.member_code);
						color_code = member.color_code;
					} else {
						color_code = this.isProjectColor
							? this.parentColor(this.value.schedule.project_code)
							: this.parentColor(this.value.schedule.member_code);
							
						if (!color_code)
							color_code = this.value.schedule.color_code;
					}
				}
				return [{ code: color_code }];
			}
		},
		maxWidth: function() {
			let font_size = 10.5;
			
			return font_size * 16 + 3 + 6;
		},
		isProjectColor: function() {
			return this.typeColor === Color.RELATION_TYPE.PROJECT;
		},
		parentColor: function() {
			return function(code) {
				const listData = (list) => {
					return list.find(l => l.code === code);
				};
				
				let parent = null;
				parent = this.isProjectColor
					? listData(this.$store.getters.projectList)
					: listData(this.$store.getters.listMember);
				
				if (parent)
					return parent.color_code;
				return null;
			}
		},
		isDefaultColor: function() {
			return function(code) {
				return this.$store.getters.displayColor(code, this.typeColor).isDefaultColor;
			}
		},
		typeColor: function() {
			if (!this.display)
				return ;
				
			return this.value.item_type === ScheduleListRow.ITEM_TYPE.PROJECT
				? Color.RELATION_TYPE.PROJECT
				: Color.RELATION_TYPE.MEMBER;
		},
	},
	watch: {
		'value.schedule.title': function (){
			if (this.value !== undefined && this.value !== null){
				this.schedule_title = this.value.schedule.title;
			}
		},
		selected_color: function() {
			if (this.selected_color)
				this.onApplyColor();
		},
	},
	created: function() {
		this.sm_window.bind(window);
	},
	beforeDestroy: function() {
		this.sm_window.unbind(window);
	},
}
</script>
<style>
	.bottom-pane-window.progress-rate {
		align-self: flex-end;
		background: #fff;
		overflow: hidden;
		margin: 0;
		min-width: 100%;
		bottom: 0;
		transition: .4s cubic-bezier(.25,.8,.5,1);
	}
	.bottom-pane-window.progress-rate .bottom-pane-header {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 56px;
	}
	.bottom-pane-window.progress-rate .bottom-pane-header-title {
		font-size: 20px;
	}
	.bottom-pane-window.progress-rate .bottom-pane-close {
		top: 0px;
		right: 0px;
	}
	.bottom-pane-window.progress-rate .bottom-pane-content {
		margin: 0px 20px 20px 20px;
	}
	.bottom-pane-window.progress-rate .rate {
		width: 60px;
		text-align: right;
		margin-top:20px;
	}
	.bottom-pane-window.progress-rate .v-slider__thumb-label {
		font-size: 25px;
	}
	.bottom-pane-window.progress-rate .v-slider__thumb {
		height: 40px;
		width: 40px;
		left: -20px;
	}
	.bottom-pane-window.progress-rate .v-slider__ticks span {
		font-size: 10px;
		padding-top: 5px;
	}
	.bottom-pane-window.progress-rate .v-slider input {
		user-select:none;
	}
	.bottom-pane-window.progress-rate .v-text-field .theme--light.v-messages {
		color: #000;
	}
	.bottom-pane-window.progress-rate .v-text-field .theme--light.v-messages {
		color: #000;
	}
	.bottom-pane-window.progress-rate .btn-add-color {
		top: -18px;
		left: 165px;
	}
</style>
